// gameengine/gameSquad.js

/**
 * Processes natural healing for all squad members
 * Healing rate affected by Medbay facilities
 * @param {Array} squad - Array of squad members
 * @param {Array} facilities - Array of base facilities
 * @returns {Array} Updated squad with healed members
 */
export const processSquadHealing = (squad, facilities) => {
  const medbays = facilities.filter(f => 
    f.type === 'medbay' && f.is_active && f.construction_days_remaining === 0
  );
  
  let healingRate = 5;
  medbays.forEach(medbay => {
    healingRate += medbay.level * 3;
  });

  return squad.map(member => {
    const isOnMission = member.status === 'On Mission';
    
    if (member.health < member.max_health && member.status !== 'KIA' && !isOnMission) {
      const newHealth = Math.min(member.health + healingRate, member.max_health);
      return {
        ...member,
        health: newHealth,
        status: newHealth === member.max_health ? 'Ready' : 'Wounded'
      };
    }
    return member;
  });
};

/**
 * Calculates the current healing rate based on medbay facilities
 * @param {Array} facilities - Array of base facilities
 * @returns {number} Daily healing rate
 */
export const getHealingRate = (facilities) => {
  const medbays = facilities.filter(f => 
    f.type === 'medbay' && f.is_active && f.construction_days_remaining === 0
  );
  
  let healingRate = 5;
  medbays.forEach(medbay => {
    healingRate += medbay.level * 3;
  });
  
  return healingRate;
};

/**
 * Checks if a squad member can be healed
 * @param {Object} member - Squad member to check
 * @returns {boolean} Whether the member can be healed
 */
export const canHeal = (member) => {
  return member.health < member.max_health && 
         member.status !== 'KIA' && 
         member.status !== 'On Mission';
};

/**
 * Applies damage to a squad member
 * @param {Object} member - Squad member
 * @param {number} damage - Amount of damage to apply
 * @returns {Object} Updated squad member
 */
export const applyDamage = (member, damage) => {
  const newHealth = Math.max(0, member.health - damage);
  const newStatus = newHealth === 0 ? 'KIA' : 
                    newHealth < member.max_health ? 'Wounded' : 'Ready';
  
  return {
    ...member,
    health: newHealth,
    status: newStatus,
    isDirty: true
  };
};

/**
 * Gets available squad members for missions
 * @param {Array} squad - Full squad array
 * @returns {Array} Available squad members
 */
export const getAvailableSquad = (squad) => {
  return squad.filter(member => 
    member.status === 'Ready' && member.health === member.max_health
  );
};